import { AuthenticateService } from './authenticate.service';
import { Injectable } from '@angular/core';
import { URL_BROWSER_NEW_LOGIN_PROD } from './../util/constants';
import { Platform } from '@ionic/angular';
import { BrowserTab } from '@ionic-native/browser-tab/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { parseUrl } from '../util/utils';
import { RequestService } from './request.service';

declare let cordova;
declare let window;

@Injectable({
  providedIn: 'root'
})
export class BrowserService {
  constructor(private iab: InAppBrowser, private platfom: Platform, private browserTab: BrowserTab,
    private request: RequestService) {
  }

  open(path: string) {
    if (this.platfom.is('cordova')) {
      this.browserTab.isAvailable()
        .then(isAvailable => {
          if (isAvailable) {
            this.browserTab.openUrl(path);
          } else {
            this.openInAppBrowser(path);
          }
        });
      return;
    }
    this.openInAppBrowser(path);
  }
  
  getHeaders(access_token?) {
    const httpOptions = {
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*',
      'Sec-Fetch-Mode':'cors',
      'Connection': 'keep-alive',
      'Content-Type': 'application/json',
      Authorization: access_token
    };

    return httpOptions;
  }


  async newOpenLogin() {
    const self = this;
    return new Promise((resolve, reject) => {
      let target = '_blank';
      if (!this.platfom.is('cordova')) {
        target = '_self';
      }
      const paramsBrowser = 'location=no,clearsessioncache=yes,clearcache=yes';
      const browser = self.iab.create(URL_BROWSER_NEW_LOGIN_PROD, target, paramsBrowser);
      if (!this.platfom.is('desktop')) {
        if (!this.platfom.is('android')) {
          browser.on('loaderror').subscribe((event) => {
            if (event.url) {
              const params = parseUrl(event.url);
              if (params && params.code) {
                browser.close();
                resolve(params);
              }
            }
          });
        } else {
          browser.on('loadstart').subscribe((event) => {
            if (event.url) {
              const params = parseUrl(event.url);
              if (params && params.code) {
                browser.close();
                resolve(params);
              }
            }
          });
        }
        browser.on('exit').subscribe((event) => {
          resolve({});
        });
      }
    });
  }

  private openInAppBrowser(path: string) {
    const target = '_self';
    const browser = this.iab.create(path, target, 'location=yes');
    browser.show();
  }

}
